var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletPointUncompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5C7.8645 4.5 4.5 7.8645 4.5 12C4.5 16.1355 7.8645 19.5 12 19.5C16.1355 19.5 19.5 16.1355 19.5 12C19.5 7.8645 16.1355 4.5 12 4.5ZM12 17.25C9.10575 17.25 6.75 14.895 6.75 12C6.75 9.105 9.10575 6.75 12 6.75C14.8942 6.75 17.25 9.105 17.25 12C17.25 14.895 14.8942 17.25 12 17.25Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.25C9.93225 8.25 8.25 9.93225 8.25 12C8.25 14.0677 9.93225 15.75 12 15.75C14.0677 15.75 15.75 14.0677 15.75 12C15.75 9.93225 14.0677 8.25 12 8.25ZM12 13.5C11.1727 13.5 10.5 12.8273 10.5 12C10.5 11.1727 11.1727 10.5 12 10.5C12.8273 10.5 13.5 11.1727 13.5 12C13.5 12.8273 12.8273 13.5 12 13.5Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletPointUncompleted);
export default __webpack_public_path__ + "static/media/bullet-point-uncompleted.58132defe908bb60da06516ba57c64a5.svg";
export { ForwardRef as ReactComponent };